module.exports = __webpack_public_path__ + "img/vol05_cup02_cover02.5a1205e9.jpg";